module.exports = __webpack_public_path__ + "img/call-center.bd87def2.png";